// @import: Urls and ajax
import {ajax, apiUrls} from '../urls';

// @define & export: Homepage page store
export default {
    state: {
        paginationTotalCount: 1,
        blogSlider: [],
        doctors: [],
        news: [],
        newsDetail: {},
        offers: [],
        specialPrograms: [],
        commentErrors: {},
        departments: [],
        departmentListing: [],
        schedules: [],
        departmentsDetail: [],
        priceAndServices: [],
        schedulesTable: {},
        departmentDoctors: [],
        departmentDropDownOptions: [],
    },

    getters: {
        paginationTotalCount(state) {
            const total = state.paginationTotalCount;
            const result = total / 20;
            return Math.ceil(result)
        },
        blogSlider(state) {
            return state.blogSlider;
        },
        doctors(state) {
            return state.doctors;
        },
        news(state) {
            return state.news;
        },
        newsDetail(state) {
            return state.newsDetail;
        },
        offers(state) {
            return state.offers;
        },
        specialPrograms(state) {
            return state.specialPrograms;
        },
        commentErrors(state) {
            return state.commentErrors;
        },
        departments(state) {
            return state.departments;
        },
        departmentListing(state) {
            return state.departmentListing;
        },
        schedules(state) {
            return state.schedules;
        },
        departmentsDetail(state) {
            return state.departmentsDetail;
        },
        departmentDropDownOptions(state) {
            const ret_data = [{value: null, name: 'Выберите направление'}]
            state.departmentDropDownOptions.forEach(el => {
                ret_data.push({name: el.title, value: el.id})
            })
            return ret_data;
        },
        priceAndServices(state) {
            let data = {
                count: state.priceAndServices.count,
                columns: [
                    {
                        displayName: "Номер",
                        name: "code"
                    },
                    {
                        displayName: "Описание",
                        name: "description"
                    },
                    {
                        displayName: "Цена, Руб",
                        name: "price"
                    },
                ],
                rows: []
            };
            let rows = [];

            for (let el of state.priceAndServices.results || []) {
                rows.push({
                        id: el.id,
                        content: {
                            code: el.code,
                            description: el.description,
                            price: el.price,
                        }
                    }
                )
            }

            data.rows = rows;

            return data;
        },
        schedulesTable(state) {
            return state.schedulesTable;
        },
        departmentDoctors(state) {
            return state.departmentDoctors;
        },
    },

    actions: {
        fetchBlogSlider({commit}) {
            return ajax.get(apiUrls.blogSliderUrl).then(response => {
                commit('setData', {key: 'blogSlider', value: response.data, module: 'home'});
            })
        },

        fetchDoctors({commit}) {
            return ajax.get(apiUrls.doctors).then(response => {
                commit('setData', {key: 'doctors', value: response.data, module: 'home'});
            })
        },

        filterDoctors({commit}, {name, department}) {
            return ajax.get(apiUrls.doctors, {params: {name: name, department: department}}).then(response => {
                commit('setData', {key: 'doctors', value: response.data, module: 'home'});
            })
        },

        fetchNews({commit}, query = {}) {
            return ajax.get(apiUrls.news, {params: query}).then(response => {
                commit('setData', {key: 'news', value: response.data, module: 'home'});
            })
        },

        fetchHomepageNews({commit}) {
            return ajax.get(apiUrls.homepageNews).then(response => {
                commit('setData', {key: 'news', value: response.data, module: 'home'});
            })
        },

        fetchNewsDetail({commit}, {type, title}) {
            return ajax.get(apiUrls.newDetail(type, title)).then(response => {
                commit('setData', {key: 'newsDetail', value: response.data, module: 'home'});
            })
        },

        fetchDocotorsDetail({commit}, slug) {
            return ajax.get(apiUrls.doctorsDetail(slug))
        },

        fetchOffers({commit}, query = {}) {
            return ajax.get(apiUrls.offers, {params: query}).then(response => {
                commit('setData', {key: 'offers', value: response.data, module: 'home'});
            });
        },

        fetchSpecialPrograms({commit}, query = {}) {
            return ajax.get(apiUrls.specialPrograms, {params: query}).then(response => {
                commit('setData', {key: 'specialPrograms', value: response.data, module: 'home'});
            });
        },

        fetchHomepageOffers({commit}, query = {}) {
            return ajax.get(apiUrls.homepageOffers, {params: query}).then(response => {
                commit('setData', {key: 'offers', value: response.data, module: 'home'});
            });
        },

        fetchDepartments({commit}) {
            return ajax.get(apiUrls.departmentsDropdown).then(response => {
                commit('setData', {key: 'departments', value: response.data, module: 'home'});
            });
        },
        fetchDepartmentListing({commit}) {
            return ajax.get(apiUrls.departments()).then(response => {
                commit('setData', {key: 'departmentListing', value: response.data, module: 'home'});
            });
        },
        fetchSchedules({commit}, search = "") {
            return ajax.get(apiUrls.schedules, {params: {search: search}}).then(response => {
                commit('setData', {key: 'schedules', value: response.data, module: 'home'});
            });
        },
        fetchSchedulesTable({commit}, {search, id}) {
            return ajax.get(apiUrls.schedulesTable(id), {params: {search: search}}).then(response => {
                commit('addSchedulesTable', {id, data: response.data});
            });
        },
        fetchDepartmentsDetail({commit}, slug) {
            return ajax.get(apiUrls.departments(slug)).then(response => {
                commit('setData', {key: 'departmentsDetail', value: response.data, module: 'home'});
            });
        },
        fetchDepartmentDropDownOptions({commit}) {
            return ajax.get(apiUrls.departmentDropDown).then(response => {
                commit('setData', {key: 'departmentDropDownOptions', value: response.data, module: 'home'});
            });
        },
        fetchPriceAndServices({commit}, {departmentUrl = "", page = 1, order_by = "", name = "", type = ""}) {
            return ajax.get(apiUrls.priceAndServicesUrl, {
                params: {
                    department: departmentUrl,
                    page: page,
                    order_by: order_by,
                    name: name,
                    type: type,
                }
            }).then(response => {
                commit("setData", {key: "paginationTotalCount", value: response.data.count, module: "home"});
                commit('setData', {key: 'priceAndServices', value: response.data, module: 'home'});
            });
        },
        fetchDepartmentDoctors({commit}, slug) {
            return ajax.get(apiUrls.departmentDoctorsUrl(slug)).then(response => {
                commit('setData', {key: 'departmentDoctors', value: response.data, module: 'home'});
            });
        }


    },

    mutations: {
        addToComments(state, data) {
            state.newsDetail.comments.push(data)
        },
        addSchedulesTable(state, {id, data}) {
            state.schedulesTable[id] = data;
            const tmpData = {...state.schedulesTable};
            state.schedulesTable = {...tmpData};
        }
    }
}
